/**
 * @fileoverview Shared guard loading indicator.
 * @module app/guards/GuardLoading
 * @description
 * Lightweight loading state rendered by route guards while they wait for async
 * conditions (auth init, profile load, health check) before deciding whether to
 * render the protected content or redirect. Mirrors the Angular guards' "wait
 * before deciding" behaviour where navigation simply did not resolve yet.
 *
 * @author Liraz Amir
 */

/** Centered loading placeholder shown while a guard resolves. */
export function GuardLoading() {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="guard-loading"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg-primary)',
        color: 'var(--text-primary)',
      }}
    >
      Loading…
    </div>
  );
}

export default GuardLoading;
